export default __webpack_public_path__ + "static/media/hamburger.31b02763.svg";